<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full lg:w-1/3 mb-base" v-bind:class="{'lg:w-1/4': pendingBalance}">
                <vx-card title="Current balance">
                    <template slot="actions">
                        <feather-icon icon="DollarSignIcon" svgClasses="w-6 h-6 text-grey"/>
                    </template>
                    <div class="text-6xl ml-2">{{balance + ' ' + currency}}</div>
                </vx-card>
            </div>

            <div class="vx-col w-full lg:w-1/4 mb-base" v-if="pendingBalance">
                <vx-card title="Pending balance">
                    <template slot="actions">
                        <feather-icon icon="DollarSignIcon" svgClasses="w-6 h-6 text-grey"/>
                    </template>
                    <div class="text-6xl ml-2">{{pendingBalance + ' ' + currency}}</div>
                </vx-card>
            </div>

            <div class="vx-col w-full lg:w-1/3 mb-base" v-bind:class="{'lg:w-1/4': pendingBalance}">
                <vx-card title="Sum of withdrawals">
                    <template slot="actions">
                        <feather-icon icon="DollarSignIcon" svgClasses="w-6 h-6 text-grey"/>
                    </template>
                    <div class="text-6xl ml-2">{{Math.abs(withdrawalsSum) + ' ' + currency}}</div>
                </vx-card>
            </div>

            <div class="vx-col w-full lg:w-1/3 mb-base" v-bind:class="{'lg:w-1/4': pendingBalance}">
                <vx-card title="Downline">
                    <template slot="actions">
                        <feather-icon icon="UsersIcon" svgClasses="w-6 h-6 text-grey"/>
                    </template>
                    <div class="text-6xl ml-2">{{descendantsNum}}</div>
                </vx-card>
            </div>
        </div>

        <div class="vx-row">

            <div class="vx-col w-full mb-base">
                <div class="vx-row">
                    <div class="vx-col w-full lg:w-1/2 mb-base lg:mb-0">
                        <vx-card title="Membership">
                            <div slot="no-body">
                                <div class="vx-row text-center">

                                    <!-- Open Tickets Heading -->
                                    <div
                                        class="vx-col w-full lg:w-1/5 md:w-full sm:w-1/5 flex flex-col justify-between mb-4 lg:order-first md:order-last sm:order-first order-last">
                                        <div class="lg:ml-6 lg:mt-6 md:mt-0 md:ml-0 sm:ml-6 sm:mt-6">
                                            <h1 class="font-bold text-5xl">{{ membership.days }}</h1>
                                            <small>Days left</small>
                                        </div>
                                    </div>

                                    <!-- Chart -->
                                    <div
                                        class="vx-col w-full lg:w-4/5 md:w-full sm:w-4/5 justify-center mx-auto lg:mt-0 md:mt-6 sm:mt-0 mt-6">
                                        <vue-apex-charts type="radialBar" height="370" :options="membershipChartOptions"
                                                         :series="[membershipRemaining]"/>
                                    </div>
                                </div>
                                <div class="flex flex-row justify-between px-8 pb-4 mt-4">

                                </div>
                            </div>
                        </vx-card>
                    </div>
                    <div class="vx-col w-full lg:w-1/2">
                        <vx-card title="Cash Out Overview">
                            <template slot="actions">
                                <feather-icon icon="DollarSignIcon" svgClasses="w-6 h-6 text-grey"/>
                            </template>

                            <template slot="no-body">
                                <div class="mt-10">
                                    <vue-apex-charts type="radialBar" height="200" :options="cashOutChartOptions"
                                                     :series="cashOutProgress"/>
                                </div>
                            </template>

                            <div class="flex justify-between text-center mt-6" slot="no-body-bottom">
                                <div
                                    class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0" v-bind:class="{'w-1/3': pendingBalance}">
                                    <p class="mt-4">Balance</p>
                                    <p class="mb-4 text-3xl font-semibold">{{balance + ' ' + currency}}</p>
                                </div>
                                <div class="w-1/3 border border-solid d-theme-border-grey-light border-r-0 border-b-0" v-if="pendingBalance">
                                    <p class="mt-4">Pending balance</p>
                                    <p class="mb-4 text-3xl font-semibold">{{pendingBalance + ' ' + currency}}</p>
                                </div>
                                <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0" v-bind:class="{'w-1/3': pendingBalance}">
                                    <p class="mt-4">Minimum Required</p>
                                    <p class="mb-4 text-3xl font-semibold">{{cashOutMinimum + ' ' + currency}}</p>
                                </div>
                            </div>
                        </vx-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import StatisticsCardLine from '../../components/statistics-cards/StatisticsCardLine';
    import VxCard from '../../components/vx-card/VxCard';
    import VueApexCharts from 'vue-apexcharts'
    import {AgGridVue} from 'ag-grid-vue';
    import '../../assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

    import RestService from '../../services/RestService';
    import {Role} from "../../enums/role";

    export default {
        name: "user-data",
        props: ['userUuid'],
        components: {
            StatisticsCardLine,
            VxCard,
            VueApexCharts,
            AgGridVue,
        },
        watch: {
            userUuid: async function () {
                this.calculateUserStatistics();
            }
        },
        methods: {
            setGridSize(params) {
                if (window.innerWidth > 1024)
                    params.api.sizeColumnsToFit();
                this.gridOptions.api.setDomLayout('autoHeight');
            },

            onUserRowSelected(event) {
                if (this.$store.state.AppActiveUser.userRole === Role.User) {
                    this.$router.push({path: '/user/downline', query: {uuid: event.node.data.uuid}});
                } else if (this.$store.state.AppActiveUser.userRole === Role.Admin) {
                    this.$router.push({path: '/admin/members/user', query: {uuid: event.node.data.uuid}});
                }
            },

            async calculateUserStatistics() {
                let balanceResponse = null;
                if (this.$store.state.AppActiveUser.userRole === Role.Admin) {
                    balanceResponse = await RestService.getUsersStatistics(this.userUuid);
                } else {
                    balanceResponse = await RestService.getUserBalance();
                }
                if (balanceResponse.success) {
                    this.balance = balanceResponse.data.balance;
                    if(balanceResponse.data.pending) {
                        this.pendingBalance = balanceResponse.data.pending;
                    }
                    this.withdrawalsSum = balanceResponse.data.withdraw;
                    this.descendantsNum = balanceResponse.data.descendants;
                }

                if (this.$store.state.AppActiveUser.userRole === Role.User && this.$store.state.AppActiveUser.membership) {
                    this.membership = this.$store.state.AppActiveUser.membership;
                }

                if (this.$store.state.AppActiveUser.userRole === Role.Admin) {
                    const membershipResponse = await RestService.getUsersMembership(this.userUuid);
                    if (membershipResponse.success) {
                        this.membership = {
                            valid: membershipResponse.data.valid,
                            days: membershipResponse.data.days
                        };

                        if (this.membership.days > 30) {
                            this.membership.days = 30;
                        }

                        if (!this.membership.valid) {
                            this.membership.days = 0;
                        }
                    }
                }

                this.membershipRemaining = Math.round(((this.membership.days / this.membershipLength * 100) + Number.EPSILON) * 100) / 100;
                if (this.membershipRemaining > 100)
                    this.membershipRemaining = 100;

                const responseMinWithdraw = await RestService.getMinWithdraw();
                if (responseMinWithdraw.success) {
                    this.cashOutMinimum = responseMinWithdraw.data.value;
                }

                if (this.balance > this.cashOutMinimum)
                    this.cashOutProgress = [100];
                else
                    this.cashOutProgress = [Math.round(((this.balance / this.cashOutMinimum * 100) + Number.EPSILON) * 100) / 100];
            }
        },
        beforeMount() {
            this.calculateUserStatistics();
        },
        computed: {
            currency() {
                return this.$store.state.currency;
            }
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
        },
        data() {
            return {
                gridOptions: {},
                gridApi: null,
                balance: 0,
                pendingBalance: null,
                withdrawalsSum: 0,
                descendantsNum: 0,
                membership: {valid: false, days: 0},
                membershipLength: 30,
                membershipRemaining: 0,
                membershipChartOptions: {
                    plotOptions: {
                        radialBar: {
                            size: 158,
                            offsetY: -30,
                            startAngle: -150,
                            endAngle: 150,
                            hollow: {
                                size: '65%'
                            },
                            track: {
                                background: 'rgba(0,0,0,0)',
                                strokeWidth: '100%'

                            },
                            dataLabels: {
                                value: {
                                    offsetY: 30,
                                    color: '#99a2ac',
                                    fontSize: '2rem'
                                }
                            }
                        }
                    },
                    colors: ['#EA5455'],
                    fill: {
                        type: 'gradient',
                        gradient: {
                            // enabled: true,
                            shade: 'dark',
                            type: 'horizontal',
                            shadeIntensity: 0.5,
                            gradientToColors: ['#7367F0'],
                            inverseColors: true,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [0, 100]
                        }
                    },
                    stroke: {
                        dashArray: 8
                    },
                    chart: {
                        sparkline: {}
                    },
                    labels: ['Membership Remaining']
                },
                cashOutMinimum: 0,
                cashOutProgress: [0],
                cashOutChartOptions: {
                    plotOptions: {
                        radialBar: {
                            size: 110,
                            startAngle: -150,
                            endAngle: 150,
                            hollow: {
                                size: '77%'
                            },
                            track: {
                                background: '#bfc5cc',
                                strokeWidth: '50%'
                            },
                            dataLabels: {
                                name: {
                                    show: false
                                },
                                value: {
                                    offsetY: 18,
                                    color: '#99a2ac',
                                    fontSize: '4rem'
                                }
                            }
                        }
                    },
                    colors: ['#00db89'],
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shade: 'dark',
                            type: 'horizontal',
                            shadeIntensity: 0.5,
                            gradientToColors: ['#00b5b5'],
                            inverseColors: true,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [0, 100]
                        }
                    },
                    stroke: {
                        lineCap: 'round'
                    },
                    chart: {
                        sparkline: {
                            enabled: true
                        },
                        dropShadow: {
                            enabled: true,
                            blur: 3,
                            left: 1,
                            top: 1,
                            opacity: 0.1
                        }
                    }
                }
            }
        }
    }
</script>
